import revive_payload_client_4sVQNw7RlN from "/app/web/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/web/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/web/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/web/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/app/web/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/web/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/app/web/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/app/web/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/app/web/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/web/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_WLsn00x1qh from "/app/web/node_modules/@nuxt/icon/dist/runtime/plugin.js";
import plugin_client_OVoKJro5pc from "/app/web/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import plugin_m51yvfcbqo from "/app/web/node_modules/@cssninja/nuxt-toaster/dist/runtime/plugin.mjs";
import plugin_jg3TSEXw60 from "/app/web/node_modules/@hebilicious/vue-query-nuxt/dist/runtime/plugin.mjs";
import directives_by0Xn3JuVB from "/app/web/node_modules/.c12/gh_ezyostudio_tairo_l93sveT08N/plugins/directives.ts";
import _2_auth_42b9fB0DY4 from "/app/web/plugins/2.auth.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_WLsn00x1qh,
  plugin_client_OVoKJro5pc,
  plugin_m51yvfcbqo,
  plugin_jg3TSEXw60,
  directives_by0Xn3JuVB,
  _2_auth_42b9fB0DY4
]